import {selectColumn, stringColumn, textAreaColumn} from "../../helpers/commonColumns";
import DataType from "../../constants/DataType";
import {softwareProduct_URL} from "../../constants/urlConfig";

export const softwareProductElementColumns = () => [
    stringColumn('code', 'Code'),
    stringColumn('name', 'Name'),
    selectColumn('softwareProductId', "Software Product", false, softwareProduct_URL, 'code'),
    {
        key: 'productVersion',
        dataIndex: 'productVersion',
        title: 'Version',
        type: DataType.TEXT,
        required: true,
        validationRules: [{min: 1}, {max: 50}]
    },
    textAreaColumn('description', 'Description', true)
];